import ParameterErrors from '../errors/ParameterErrors';
import GenericWindow from '../window/GenericWindow';
import Dialog from '../components/Dialog';
import WindowType from '../enums/WindowType';
import getViewportDimensions from '../ui_core/getViewportDimensions';
import PlotDetailedInformationsManager from './PlotDetailedInformationsManager';
import PlotDetailedInformationSectionType from './PlotDetailedInformationSectionType';
import './PlotComparisonManager.css';
const {throwNotProvided}=ParameterErrors;
export default class PlotComparisonScrollManager {
	constructor({plotDetailedInformations}){
		this.dispose= this.dispose.bind(this);
		this._plotDetailedInformations = plotDetailedInformations;
		this._onPlotDetailedInformationWindowFocused = this._onPlotDetailedInformationWindowFocused.bind(this);
		this._releasePreviouslyFocusedPlotDetailedInformation = this._releasePreviouslyFocusedPlotDetailedInformation.bind(this);
		this._setFocusedPlotDetailedInformation = this._setFocusedPlotDetailedInformation.bind(this);
		this._currentlyFocusedPlotDetailedInformationScrolled = this._currentlyFocusedPlotDetailedInformationScrolled.bind(this);
		this.dispose = this.dispose.bind(this);
		this._currentlyFocusedPlotDetailedInformation = null;
		plotDetailedInformations.forEach(plotDetailedInformation=>{
			plotDetailedInformation.window.addEventListener(GenericWindow.EventNames.FOCUSSED,
				this._onPlotDetailedInformationWindowFocused);
			plotDetailedInformation.window.getElement().addEventListener('mouseenter', ()=>
				this._onPlotDetailedInformationWindowFocused({window:plotDetailedInformation.window}));
			plotDetailedInformation.window.getElement().addEventListener('touchstart', ()=>
				this._onPlotDetailedInformationWindowFocused({window:plotDetailedInformation.window}));
		});
	}
	_onPlotDetailedInformationWindowFocused(e){
		this._focussed = true;
		const windowHash = e.window.getHash();
		const plotDetailedInformation = this._plotDetailedInformations.filter(plotDetailedInformation=>plotDetailedInformation.window.getHash()===windowHash)[0];
		if(plotDetailedInformation===undefined)return;
		this._setFocusedPlotDetailedInformation(plotDetailedInformation);
	}
	_setFocusedPlotDetailedInformation(plotDetailedInformation){
		if(this._currentlyFocusedPlotDetailedInformation===plotDetailedInformation)return;
		this._releasePreviouslyFocusedPlotDetailedInformation();
		this._currentlyFocusedPlotDetailedInformation = plotDetailedInformation;
		this._currentlyFocusedPlotDetailedInformation.addEventListener('scrolled', this._currentlyFocusedPlotDetailedInformationScrolled);
	}
	_releasePreviouslyFocusedPlotDetailedInformation(){
		if(this._currentlyFocusedPlotDetailedInformation===null)return;
		this._currentlyFocusedPlotDetailedInformation.removeEventListener('scrolled', this._currentlyFocusedPlotDetailedInformationScrolled);
		this._currentlyFocusedPlotDetailedInformation = null;
	}
	_currentlyFocusedPlotDetailedInformationScrolled(e){
		const plotDetailedInformation = e.plotDetailedInformation;
		const sectionTypeAndProportion =plotDetailedInformation.sectionTypeAndProportionScrolled;
		if(!sectionTypeAndProportion)return;
		const {sectionType, proportion} = sectionTypeAndProportion;
		this._plotDetailedInformations.forEach(plotDetailedInformationToScroll=>{
			if(plotDetailedInformationToScroll===plotDetailedInformation)return;
			plotDetailedInformationToScroll.scrollToSectionWithProportion(sectionType, proportion);
		});
	}
	dispose(){
		this._plotDetailedInformations.forEach(plotDetailedInformation=>{
			plotDetailedInformation.window.removeEventListener(GenericWindow.EventNames.FOCUSSED,
				this._onPlotDetailedInformationWindowFocused);
		});
		this._releasePreviouslyFocusedPlotDetailedInformation();
	}
}